import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function EnrichmentIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <Box as="circle" cx="17.5" cy="13.5" r="5" stroke="currentColor" />
      <Box
        as="path"
        fill="currentColor"
        fillRule="evenodd"
        d="M3.165 2.083h13.667c.598 0 1.084.485 1.084 1.083v5.142h1.083V3.166c0-1.196-.97-2.166-2.167-2.166H3.165C1.97 1 1 1.97 1 3.166v17.667C1 22.03 1.97 23 3.166 23h13.667C18.03 23 19 22.03 19 20.833v-2.371h-1.083v2.37c0 .6-.486 1.084-1.084 1.084H3.165a1.083 1.083 0 0 1-1.083-1.083V3.166c0-.598.485-1.083 1.083-1.083Z"
        clipRule="evenodd"
      />
      <Box
        as="path"
        stroke="currentColor"
        d="M4.998 5.5h10m-10 4h9.5m-9.5 8h9.5m-9.5-3.962h7.462M15 13.5h5M17.498 11v5"
      />
    </Icon>
  );
}
